export default __webpack_public_path__ + "static/media/login-02.7794e36d.jpg";